import { useState } from 'react'
import { Check, ChevronsUpDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { cn } from '@/lib/utils'

type CourseComboboxProps = {
  courses: Array<{ name: string; fill: string }>
  activeCourse: string
  setActiveCourse: (course: string) => void
  width?: string
}

export function CourseCombobox({ courses, activeCourse, setActiveCourse, width = 'w-[12.5rem]' }: CourseComboboxProps) {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className={`${width} justify-between`}>
          {activeCourse || 'Total'}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={width + 'p-0'}>
        <Command>
          <CommandInput placeholder="Search course..." />
          <CommandList>
            <CommandEmpty>No course found.</CommandEmpty>
            <CommandGroup>
              <CommandItem
                value="total"
                onSelect={() => {
                  setActiveCourse('')
                  setOpen(false)
                }}
              >
                <Check className={cn('mr-2 h-4 w-4', !activeCourse ? 'opacity-100' : 'opacity-0')} />
                Total
              </CommandItem>
              {courses.map((course) => (
                <CommandItem
                  key={course.name}
                  value={course.name}
                  onSelect={(currentValue) => {
                    setActiveCourse(currentValue === activeCourse ? '' : currentValue)
                    setOpen(false)
                  }}
                >
                  <Check className={cn('mr-2 h-4 w-4', activeCourse === course.name ? 'opacity-100' : 'opacity-0')} />
                  <span className="mr-2 h-3 w-3 shrink-0 rounded-sm" style={{ backgroundColor: course.fill }} />
                  {course.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
